(function ($) {
    var windowWidth = $(window).width();
    var stickyContent = $('.product-detail__main_content');
    var wrapper = $('.product-detail__main');
    var gallery = $('.product-detail__gallery');
    var description = $('.product-detail__description');
    var leftSideHeight = Math.round(description.outerHeight()) + Math.round(gallery.outerHeight()) + 40;

    if(!stickyContent.length){
        return
    }

    var contentHeight = Math.round(stickyContent.outerHeight()),
        contentTop = Math.round($(wrapper).offset().top),
        wrapperHeight = Math.round(wrapper.outerHeight()),
        heightDifference = contentHeight - $(window).height(),
        topOffset = 30,
        lastScroll = 0,
        currentMargin = 0,
        currentDistanceFromBottomUp = $(stickyContent).offset().top,
        currentDistanceFromBottomDown = contentTop + contentHeight,
        scroll = Math.round($(document).scrollTop()),
        bottomScroll = scroll + Math.round($(window).height());


    function content_scroll_sticky() {
        contentHeight = Math.round(stickyContent.outerHeight());
        contentTop = Math.round($(wrapper).offset().top);
        wrapperHeight = Math.round(wrapper.outerHeight());
        heightDifference = contentHeight - $(window).height();
        lastScroll = 0;
        currentMargin = 0;
        currentDistanceFromBottomUp = $(stickyContent).offset().top;
        currentDistanceFromBottomDown = contentTop + contentHeight;
        scroll = Math.round($(document).scrollTop());
        bottomScroll = scroll + $(window).height();
        if (contentHeight > $(window).height() && contentHeight < leftSideHeight - topOffset) {
            if(!$('.scrollMargin').length) {
                $("<div class='scrollMargin'></div>").insertBefore(stickyContent);
            }
        } else {
            stickyContent.css({'top': 30+'px'});
        }
        function setScrollUp(){
            if (contentHeight > $(window).height() && contentHeight < leftSideHeight - topOffset){
                stickyContent.css({'bottom': -heightDifference - topOffset, 'top': ''});

                if (scroll < currentDistanceFromBottomUp && scroll < currentMargin + contentTop && scroll > contentTop - topOffset){
                    $('.scrollMargin').css({'margin-top': scroll - contentTop + topOffset});
                    currentMargin = $(stickyContent).offset().top - $(wrapper).offset().top;
                } else if(scroll + topOffset < contentTop)  {
                    $('.scrollMargin').css({'margin-top': '0'});
                } else if(bottomScroll > contentTop + wrapperHeight) {
                    $('.scrollMargin').css({'margin-top': wrapperHeight - contentHeight});
                    currentMargin = wrapperHeight - contentHeight;
                }

                currentDistanceFromBottomUp = $(stickyContent).offset().top - topOffset;
            }
        }

        function setScrollDown(){
            if (contentHeight > $(window).height()  && contentHeight < leftSideHeight - topOffset){
                stickyContent.css({'bottom': '', 'top': -heightDifference})

                if (bottomScroll > currentDistanceFromBottomDown && bottomScroll < wrapperHeight + contentTop){
                    $('.scrollMargin').css({'margin-top': scroll - contentTop - heightDifference});
                    currentMargin = $(stickyContent).offset().top - $(wrapper).offset().top;
                } else if(scroll + topOffset < contentTop)  {
                    $('.scrollMargin').css({'margin-top': '0'});
                } else if(bottomScroll > contentTop + wrapperHeight) {
                    $('.scrollMargin').css({'margin-top': wrapperHeight - contentHeight});
                    currentMargin = wrapperHeight - contentHeight;
                }

                currentDistanceFromBottomDown = $(stickyContent).offset().top + stickyContent.outerHeight();
            }
        }

        setScrollUp();
        setScrollDown();


        $(document).on('scroll', function () {
            scroll = $(document).scrollTop();
            bottomScroll = scroll + $(window).height();
            if(lastScroll - scroll > 0) { //scroll up
                setScrollUp()
            } else { //scroll down
                setScrollDown()
            }
            lastScroll = scroll;
        });


    }

    window.addEventListener('resize', () => {
        if ($(window).width() == windowWidth) return;
        setTimeout(() => {
            content_scroll_sticky();
        }, 10)
    });
    $("[data-show-more-gallery]").click(function () {
        setTimeout(() => {
            content_scroll_sticky();
        }, 10)
    })
    $(".product__colors_color-button").click(function () {
        setTimeout(() => {
            content_scroll_sticky();
        }, 10)
    })
    $(document).gp_ready(function (){
        if($('.product-detail__main_content').length) {
            content_scroll_sticky();
        }
    })

    // Scroll to reviews from the product detail header
    $("a.product-detail-header__rating-link").on("click", function (){
        $('html, body').animate({
            scrollTop: $('.product-detail__reviews').offset().top - 10
        }, 1000);
    })

})(jQuery);